import { MIN_TOPUP_AMOUNT } from "../precision";

export const loginSchema = () => {
  return [
    {
      title: "email",
      type: "string",
      required: true,
    },
    {
      title: "password",
      type: "string",
      required: true,
    },
  ];
};

export const forgotPasswordSchema = () => {
  return [
    {
      title: "email",
      type: "string",
      required: true,
    },
  ];
};

export const forgotPasswordEmailCodeSchema = () => {
  return [
    {
      title: "email",
      type: "string",
      required: true,
    },
    {
      title: "otp",
      type: "string",
      required: true,
    },
  ];
};

export const forgotPasswordResetSchema = () => {
  return [
    {
      title: "email",
      type: "string",
      required: true,
    },
    {
      title: "otp",
      type: "string",
      required: true,
    },
    {
      title: "password",
      type: "string",
      required: true,
    },
    {
      title: "confirmPassword",
      type: "string",
      required: true,
    },
    {
      type: "confirmPasswordMatch",
      required: true,
    },
  ];
};

export const newOrderCustomerDetailsSchema = () => {
  return [
    {
      title: "customerPhone",
      type: "number",
      required: true,
      message: `Please enter phone number`,
    },
    {
      title: "customerName",
      type: "string",
      required: true,
      message: `Please enter name`,
    },
    {
      title: "paymentType",
      type: "string",
      required: true,
      message: `Please select an option`,
    },
    {
      title: "orderAmount",
      type: "number",
      required: true,
      message: `Please enter amount`,
    },
    {
      title: "vehicleType",
      type: "string",
      required: false,
      message: `Please select an option`,
    },
    {
      title: "status",
      type: "string",
      required: true,
      message: `Please select an option`,
    },
    {
      title: "description",
      type: "string",
      required: false,
    },
  ];
};

export const newOrderCustomerAddressSchema = () => {
  return [
    {
      title: "area",
      type: "object",
      required: true,
      message: `Please select area`,
    },
    {
      title: "block",
      type: "object",
      required: true,
      message: `Please select block`,
    },
    {
      title: "street",
      type: "object",
      required: true,
      message: `Please select street`,
    },
    {
      title: "building",
      type: "string",
      required: false,
      message: `Please enter building details`,
    },
    {
      title: "jadda",
      type: "string",
      required: false,
      message: `Please enter jadda details`,
    },
    {
      title: "apartment",
      type: "string",
      required: false,
      message: `Please enter apartment details`,
    },
    {
      title: "floor",
      type: "string",
      required: false,
      message: `Please enter floor details`,
    },
    {
      title: "notes",
      type: "string",
      required: false,
    },
    {
      title: "distance",
      type: "string",
      required: true,
      message: `Distance missing`,
    },
    {
      title: "time",
      type: "string",
      required: true,
      message: `Time missing`,
    },
    {
      title: "fee",
      type: "string",
      required: true,
      message: `Fee missing`,
    },
    {
      title: "feeInt",
      type: "string",
      required: true,
      message: `Fee missing`,
    },
  ];
};

export const newOrderTimeSchema = () => {
  return [
    {
      title: "status",
      type: "string",
      required: true,
      message: `Please select an option`,
    },
  ];
};

export const employeeSchema = () => {
  return [
    {
      title: "name",
      type: "string",
      required: true,
      message: `Please enter employee name`,
    },
    {
      title: "email",
      type: "string",
      required: true,
      message: `Please enter email`,
    },
    {
      title: "role",
      type: "string",
      required: true,
      message: `Please select role`,
    },
    {
      title: "branchId",
      type: "string",
      required: true,
      message: `Please select branch`,
    },
  ];
};

export const branchSchema = () => {
  return [
    {
      title: "name",
      type: "string",
      required: true,
      message: `Please enter branch name`,
    },
    {
      title: "phone",
      type: "string",
      required: true,
      message: `Please enter phone number`,
    },
    {
      title: "area",
      type: "object",
      required: true,
      message: `Please select area`,
    },
    {
      title: "block",
      type: "object",
      required: true,
      message: `Please select block`,
    },
    {
      title: "street",
      type: "object",
      required: true,
      message: `Please select street`,
    },
    {
      title: "building",
      type: "string",
      required: true,
      message: `Please enter building name`,
    },
    {
      title: "jadda",
      type: "string",
      required: true,
      message: `Please enter jadda`,
    },
    {
      title: "apartment",
      type: "string",
      required: true,
      message: `Please enter apartment`,
    },
    {
      title: "floor",
      type: "string",
      required: true,
      message: `Please enter floor`,
    },
    {
      title: "latitude",
      type: "latitude",
      required: false,
      message: `Enter valid co-ordinate`,
    },
    {
      title: "longitude",
      type: "longitude",
      required: false,
      message: `Enter valid co-ordinate`,
    },
  ];
};

export const employeeProfileSchema = () => {
  return [
    {
      title: "name",
      type: "string",
      required: true,
      message: `Please enter name`,
    },
    {
      title: "email",
      type: "string",
      required: true,
      message: `Please enter email`,
    },
  ];
};

export const employeeProfileSecuritySchema = () => {
  return [
    {
      title: "oldPassword",
      type: "string",
      required: true,
      message: `Please enter old password`,
    },
    {
      title: "password",
      type: "string",
      required: true,
      message: `Please enter new password`,
    },
    {
      title: "confirmPassword",
      type: "string",
      required: true,
      message: `Please confirm new password`,
    },
  ];
};

export const webhookSchema = () => {
  return [
    {
      title: "webhook",
      type: "string",
      required: true,
      message: `Please enter webhook url`,
    },
  ];
};

export const paymentDetailsSchema = () => {
  return [
    {
      title: "amount",
      type: "paymentAmount",
      required: true,
      min: MIN_TOPUP_AMOUNT,
      message: `Minimum recharge amount is ${MIN_TOPUP_AMOUNT}`,
    },
    {
      title: "paymentMethod",
      type: "string",
      required: true,
      message: `Please select an option`,
    },
  ];
};
